import React, { Component } from "react";
import {
  Box,
  Paper,
  Typography,
  Grid,
  TextField,
  Button,
  Divider,
  MenuItem,
} from "@mui/material";
import Sidebar from "../Sidebar";
import DownloadIcon from "@mui/icons-material/Download";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import FormatListNumberedOutlinedIcon from "@mui/icons-material/FormatListNumberedOutlined";
import base from "../base.json";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";

const drawerWidth = 80;
export class Addbuilders extends Component {
  constructor(props) {
    super(props);
    this.state = {

        builder_name : "",

    builder_address: "",
    builder_contact_no: "",

    builder_second_contact_no: "",
    builder_email_id: "",

    builder_logo : "",
    builder_description: "",
    
    builder_login_passcode: "",
      

      is_switch_case: true,
    };
    this.handleChange = this.handleChange.bind();
  }

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleChangee = (e) => {
    this.setState({
      [e.target.name]: e.target.files[0],
    });
  };

  handleChangeee = (e) => {
    this.setState({
      [e.target.name]: e.target.files,
    });
  };


  
  save = () => {
    
    if (
             this.state.builder_name != "",

    this.state.builder_address!= "",
    this.state.builder_contact_no!= "",

    this.state.builder_second_contact_no!= "",
    this.state.builder_email_id!= "",

    this.state.builder_logo != "",
    this.state.builder_description!= "",
    
    this.state.builder_login_passcode!= ""

    ) {

      let formdata = new FormData();

      formdata.append("builder_name", this.state.builder_name);
      formdata.append(
        "builder_address",
        this.state.builder_address
      );

      formdata.append("builder_contact_no", this.state.builder_contact_no);
    
      formdata.append(
        "builder_email_id",
        this.state.builder_email_id
      );
      formdata.append("builder_logo", this.state.builder_logo);
      formdata.append("builder_description", this.state.builder_description);
      formdata.append("builder_login_passcode", this.state.builder_login_passcode);
     

      this.setState({ is_loader_shows: true }, () => {
        fetch(
          `${base.base_url}/property_portal/admin/builder/AddNewbuilder`,
          {
            /*
        headers: {
                                "content-type": "multipart/form-data",
                              },
                              */
            method: "post",
            body: formdata,
          }
        )
          .then((res) => {
            return res.json();
          })
          .then(() => {
            alert("done");
          });
      });
    } else {
      alert("fill all fields");
    }

  };
  

  render() {
    return (
      <Box sx={{ display: "flex" }}>
        <Sidebar />
        <Box
          sx={{ width: { sm: `calc(100% - ${drawerWidth}px)`, xs: "100%" } }}
        >
          <Box sx={{ height: "100%", width: "100%" }}>
            <Box
              sx={{
                height: 47,
                //  width: "100%",
                backgroundColor: "#fff",
                borderRadius: 0,
                mt: 0.2,
                borderBottom: 0.5,
                borderBottomColor: "#dddddd",
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography sx={{ fontSize: 18, ml: 1 }}>
                Add New Builder
              </Typography>

              <Link to="/">
                <Button
                  variant="contained"
                  size="samll"
                  startIcon={
                    <FormatListNumberedOutlinedIcon
                      sx={{ height: 20, width: 20 }}
                    />
                  }
                  disableElevation
                  sx={{
                    height: 25,
                    fontSize: 13,
                    textTransform: "none",
                    backgroundColor: "#288ade",
                    mr: 1,
                  }}
                >
                  Builder List
                </Button>
              </Link>
            </Box>

            <Box
              sx={{
                pl: { xs: 1, sm: 3 },
                pt: { xs: 1, sm: 3 },
                pr: { xs: 1, sm: 3 },
                display: this.state.is_switch_case ? "block" : "none",
              }}
            >
              <Box>
                <Paper
                  variant="outlined"
                  elevation={1}
                  style={{ minHeight: 150, width: "100%", color: "#fff" }}
                >
                  <Box sx={{ padding: 3 }}>
                    <Typography
                      style={{
                        fontWeight: "bold",
                        color: "#1b7bce",
                        fontSize: 13,
                        marginTop: 3,
                        textTransform: "uppercase",
                        marginBottom: 8,
                        marginLeft: 1,
                      }}
                    >
                      Fill property details
                    </Typography>

                    <Grid container spacing={2}>
                      <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography
                          sx={{
                            fontSize: 11,
                            color: "#515151",
                            fontWeight: "bold",
                            p: 0.5,
                          }}
                        >
                          Builder name
                        </Typography>
                        <TextField
                          size="small"
                          fullWidth
                          placeholder="Builder name"
                          InputProps={{
                            style: { fontSize: 11, fontWeight: "500" },
                          }}
                          name="builder_name"
                          value={this.state.builder_name}
                          onChange={this.handleChange}
                        />
                      </Grid>

                      <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography
                          sx={{
                            fontSize: 11,
                            color: "#515151",
                            fontWeight: "bold",
                            p: 0.5,
                          }}
                        >
                          Builder Address
                        </Typography>
                        <TextField
                          size="small"
                          fullWidth
                          placeholder="Adress"
                          InputProps={{
                            style: { fontSize: 11, fontWeight: "500" },
                          }}
                          name="builder_address"
                          value={this.state.builder_address}
                          onChange={this.handleChange}
                             />
                      </Grid>

                      <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography
                          sx={{
                            fontSize: 11,
                            color: "#515151",
                            fontWeight: "bold",
                            p: 0.5,
                          }}
                        >
                          Builder contact no
                        </Typography>
                        <TextField
                          size="small"
                          type="text"
                          placeholder="contact no"
                          fullWidth
                          InputProps={{
                            style: { fontSize: 11, fontWeight: "500" },
                          }}
                          name="builder_contact_no"
                          value={this.state.builder_contact_no}
                          onChange={this.handleChange}
                           />

                      </Grid>

                      <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography
                          sx={{
                            fontSize: 11,
                            color: "#515151",
                            fontWeight: "bold",
                            p: 0.5,
                          }}
                        >
                         Second contact no
                        </Typography>
                        <TextField
                          size="small"
                          type="text"
                          placeholder="contact no"
                          fullWidth
                          InputProps={{
                            style: { fontSize: 11, fontWeight: "500" },
                          }}
                          name="builder_second_contact_no"
                          value={this.state.builder_second_contact_no}
                          onChange={this.handleChange}
                        />
                      </Grid>

                      <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography
                          sx={{
                            fontSize: 11,
                            color: "#515151",
                            fontWeight: "bold",
                            p: 0.5,
                          }}
                        >
                          Builder Email ID
                        </Typography>
                        <TextField
                          size="small"
                          type="text"
                          placeholder="Email"
                          fullWidth
                          InputProps={{
                            style: { fontSize: 11, fontWeight: "500" },
                          }}
                          name="builder_email_id"
                          value={this.state.builder_email_id}
                          onChange={this.handleChange}
                        />
                      </Grid>

                   

                         <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography
                          sx={{
                            fontSize: 11,
                            color: "#515151",
                            fontWeight: "bold",
                            p: 0.5,
                          }}
                        >
                         Description
                        </Typography>
                        <TextField
                          size="small"
                          type="text"
                          placeholder="builder_description"
                          fullWidth
                          InputProps={{
                            style: { fontSize: 11, fontWeight: "500" },
                          }}
                          name="builder_description"
                          value={this.state.builder_description}
                          onChange={this.handleChange}
                        />
                      </Grid>


                      <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography
                          sx={{
                            fontSize: 11,
                            color: "#515151",
                            fontWeight: "bold",
                            p: 0.5,
                          }}
                        >
                         password
                        </Typography>
                        <TextField
                          size="small"
                          type="text"
                          placeholder="Password"
                          fullWidth
                          InputProps={{
                            style: { fontSize: 11, fontWeight: "500" },
                          }}
                          name="builder_login_passcode"
                          value={this.state.builder_login_passcode}
                          onChange={this.handleChange}
                        />
                      </Grid>

                      <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography
                          sx={{
                            fontSize: 11,
                            color: "#515151",
                            fontWeight: "bold",
                            p: 0.5,
                          }}
                        >
                          Logo
                        </Typography>
                        <Box
                          sx={{
                            width: "100%",
                            height: 32,
                            backgroundColor: "#f8f8f8",
                            border: 1,
                            borderColor: "#a0a0a0",
                            borderRadius: 1,
                          }}
                        >
                          <input
                            type="file"
                            name="builder_logo"
                            onChange={this.handleChangee}
                            style={{
                              margin: 6,
                              paddingTop: 2,
                              borderRadius: 2,
                              color: "grey",
                              fontSize: 10,
                            }}
                          />
                        </Box>
                      </Grid>

             
                    </Grid>

    

                    <br />

                    <Box>
                      <Button
                        size="small"
                        variant="contained"
                        sx={{ textTransform: "none", fontSize: 12 }}
                        onClick={this.save}
                      >
                        Save Builder Details
                      </Button>
                    </Box>
                  </Box>
                </Paper>
              </Box>

              <br />
              <br />
              <br />
            </Box>
          </Box>
        </Box>
      </Box>
    );
  }
}

export default Addbuilders;

export function Addbuildersc(props) {
  const navigate = useNavigate();
  const location = useLocation();
  const param = useParams();
  return <Addbuilders param={param} navigate={navigate}></Addbuilders>;
}




 






